module.exports = __webpack_public_path__ + "img/media-18.8f2d4f0a.png";